import type { TranslationKey } from './translations';

export const METRO_STATION = 'MetroStation';
export const BUS_STATION = 'BusStation';
export const TRAIN_STATION = 'TrainStation';
export const AIRPORT = 'Airport';
export const RESTAURANT = 'Restaurant';
export const BEACH = 'Beach';
export const SHOPPING_MALL = 'ShoppingMall';
export const LEISURE_CENTER_BUILDING = 'LeisureCenterBuilding';
export const AMUSEMENT_PARK = 'AmusementPark';
export const PARK = 'Park';
export const CAMPGROUND = 'Campground';
export const CAR_RENTAL = 'CarRental';
export const CASINO_BUILDING = 'CasinoBuilding';
export const CINEMA_HALL = 'CinemaHall';
export const CONCERT_HALL = 'ConcertHall';
export const FRONTIER_CROSSING = 'FrontierCrossing';
export const HARBOR = 'Harbor';
export const HOSPITAL = 'Hospital';
export const LIBRARY = 'Library';
export const MUSEUM = 'Museum';
export const RELIGIOUS_BUILDING = 'ReligiousBuilding';
export const ZOO = 'Zoo';
export const BRIDGE = 'Bridge';
export const CASTLE = 'Castle';
export const CAVE = 'Cave';
export const DESERT = 'Desert';
export const FARM = 'Farm';
export const FERRIS_WHEEL = 'FerrisWheel';
export const FILM_STUDIO = 'Film studio';
export const FOUNTAIN = 'Fountain';
export const GARDEN = 'Garden';
export const GRASSLAND = 'Grassland';
export const HOT_SPRING = 'Hot Spring';
export const MODERN_ARCHITECTURE = 'ModernArchitecture';
export const WORKSHOP = 'Workshop';
export const ART_CENTER = 'ArtCenter';
export const ART_GALLERY = 'ArtGallery';
export const CAR_PARK_INDOORS = 'CarParkIndoors';
export const CAR_PARK_OUTDOORS = 'CarParkOutdoors';
export const CAR_PARK = 'CarPark';
export const MOUNTAIN_PASS = 'MountainPass';
export const MOUNTAIN_PEAK = 'MountainPeak';
export const FOREST = 'Forest';
export const NATURE_RESERVE = 'NatureReserve';
export const RIVER = 'River';
export const SPRING = 'Spring';
export const LAKE = 'Lake';
export const WATERFALL = 'Waterfall';
export const VOLCANO = 'Volcano';
export const WETLAND = 'Wetland';
export const CANYON = 'Canyon';
export const MONUMENT_LANDMARK = 'MonumentLandmark';
export const HISTORIC_SITE = 'HistoricSite';
export const TOURIST_ATTRACTION = 'TouristAttraction';
export const TOURIST_INFORMATION_OFFICE = 'TouristInformationOffice';
export const CONVENTION_HALL = 'ConventionHall';
export const EXHIBITION_CENTER_BUILDING = 'ExhibitionCenterBuilding';
export const CULTURAL_CENTER_BUILDING = 'CulturalCenterBuilding';
export const GOLF_COURSE = 'GolfCourse';
export const SKI_STATION = 'SkiStation';
export const SPORTS_FACILITY = 'SportsFacility';
export const STADIUM = 'Stadium';
export const THEATRE_HALL = 'TheatreHall';
export const OPERA_HALL = 'OperaHall';
export const TRANSITWAY_PLAZA = 'TransitwayPlaza';
export const SCHOOL = 'School';
export const UNIVERSITY_BUILDING = 'UniversityBuilding';
export const EMBASSY_BUILDING = 'EmbassyBuilding';
export const GOVERNMENT_BUILDING = 'GovernmentBuilding';
export const COURTHOUSE = 'Courthouse';

export const poiSaasMap: Record<string, TranslationKey> = {
  [AMUSEMENT_PARK]: 'HotelDetail_map__poi__AmusementPark',
  [PARK]: 'HotelDetail_map__poi__Park',
  [BEACH]: 'HotelDetail_map__poi__Beach',
  [CAR_RENTAL]: 'HotelDetail_map__poi__CarRental',
  [CASINO_BUILDING]: 'HotelDetail_map__poi__CasinoBuilding',
  [CINEMA_HALL]: 'HotelDetail_map__poi__CinemaHall',
  [CONCERT_HALL]: 'HotelDetail_map__poi__ConcertHall',
  [FRONTIER_CROSSING]: 'HotelDetail_map__poi__FrontierCrossing',
  [HARBOR]: 'HotelDetail_map__poi__Harbor',
  [HOSPITAL]: 'HotelDetail_map__poi__Hospital',
  [LIBRARY]: 'HotelDetail_map__poi__Library',
  [MUSEUM]: 'HotelDetail_map__poi__Museum',
  [RELIGIOUS_BUILDING]: 'HotelDetail_map__poi__ReligiousBuilding',
  [ZOO]: 'HotelDetail_map__poi__Zoo',
  [BRIDGE]: 'HotelDetail_map__poi__Bridge',
  [CASTLE]: 'HotelDetail_map__poi__Castle',
  [CAVE]: 'HotelDetail_map__poi__Cave',
  [DESERT]: 'HotelDetail_map__poi__Desert',
  [FARM]: 'HotelDetail_map__poi__Farm',
  [FERRIS_WHEEL]: 'HotelDetail_map__poi__FerrisWheel',
  [FILM_STUDIO]: 'HotelDetail_map__poi__FilmStudio',
  [FOUNTAIN]: 'HotelDetail_map__poi__Fountain',
  [GARDEN]: 'HotelDetail_map__poi__Garden',
  [GRASSLAND]: 'HotelDetail_map__poi__Grassland',
  [HOT_SPRING]: 'HotelDetail_map__poi__HotSpring',
  [MODERN_ARCHITECTURE]: 'HotelDetail_map__poi__ModernArchitecture',
  [WORKSHOP]: 'HotelDetail_map__poi__Workshop',
  [ART_CENTER]: 'HotelDetail_map__poi__Art',
  [ART_GALLERY]: 'HotelDetail_map__poi__Art',
  [CAR_PARK_INDOORS]: 'HotelDetail_map__poi__CarPark',
  [CAR_PARK]: 'HotelDetail_map__poi__CarPark',
  [MOUNTAIN_PASS]: 'HotelDetail_map__poi__Nature',
  [MOUNTAIN_PEAK]: 'HotelDetail_map__poi__Nature',
  [FOREST]: 'HotelDetail_map__poi__Nature',
  [NATURE_RESERVE]: 'HotelDetail_map__poi__Nature',
  [RIVER]: 'HotelDetail_map__poi__Nature',
  [SPRING]: 'HotelDetail_map__poi__Nature',
  [LAKE]: 'HotelDetail_map__poi__Nature',
  [WATERFALL]: 'HotelDetail_map__poi__Nature',
  [VOLCANO]: 'HotelDetail_map__poi__Nature',
  [WETLAND]: 'HotelDetail_map__poi__Nature',
  [CANYON]: 'HotelDetail_map__poi__Nature',
  [MONUMENT_LANDMARK]: 'HotelDetail_map__poi__Attractions',
  [HISTORIC_SITE]: 'HotelDetail_map__poi__Attractions',
  [TOURIST_ATTRACTION]: 'HotelDetail_map__poi__Attractions',
  [TOURIST_INFORMATION_OFFICE]: 'HotelDetail_map__poi__Attractions',
  [CONVENTION_HALL]: 'HotelDetail_map__poi__CulturalCentre',
  [EXHIBITION_CENTER_BUILDING]: 'HotelDetail_map__poi__CulturalCentre',
  [CULTURAL_CENTER_BUILDING]: 'HotelDetail_map__poi__CulturalCentre',
  [GOLF_COURSE]: 'HotelDetail_map__poi__Sports',
  [SKI_STATION]: 'HotelDetail_map__poi__Sports',
  [SPORTS_FACILITY]: 'HotelDetail_map__poi__Sports',
  [STADIUM]: 'HotelDetail_map__poi__Sports',
  [THEATRE_HALL]: 'HotelDetail_map__poi__Theatre',
  [OPERA_HALL]: 'HotelDetail_map__poi__Theatre',
  [LEISURE_CENTER_BUILDING]: 'HotelDetail_map__poi__Entertainment',
  [SHOPPING_MALL]: 'HotelDetail_map__poi__Entertainment',
  [TRANSITWAY_PLAZA]: 'LOCATIONGROUP_Landmark',
  [SCHOOL]: 'HotelDetail_map__poi__School',
  [UNIVERSITY_BUILDING]: 'HotelDetail_map__poi__School',
  [BUS_STATION]: 'HotelDetail_map__poi__BusStation',
  [TRAIN_STATION]: 'HotelDetail_map__poi__TrainStation',
  [METRO_STATION]: 'HotelDetail_map__poi__MetroStation',
  [AIRPORT]: 'HotelDetail_map__poi__Airport',
  [EMBASSY_BUILDING]: 'HotelDetail_map__poi__EmbassyBuilding',
  [GOVERNMENT_BUILDING]: 'HotelDetail_map__poi__GovernmentBuilding',
  [COURTHOUSE]: 'HotelDetail_map__poi__Courthouse',
};
